export default function leadStageTitleOf(stageName) {
    const titlesByStageName = {
        UNASSIGNED: 'Sin asignar',
        NEW: 'Nuevo Lead',
        CONTACTED: 'Contactado',
        NEGOTIATION: 'Negociación',
        PRODUCT_TRIAL: 'Prueba de Producto',
        REGISTRATION_REQUEST: 'Solicitud de Alta',
        REGISTERED: 'Dado de Alta',
        CLOSED: 'Cerrado',
        STAND_BY: 'Stand By',
        CURRENT_CUSTOMER: 'Cliente actual',
        NOT_APPLICABLE: 'No aplica',
    };
    return titlesByStageName[stageName];
}
